import { render, staticRenderFns } from "./WorkCompanyGeneral.vue?vue&type=template&id=75928f35"
import script from "./WorkCompanyGeneral.vue?vue&type=script&lang=js"
export * from "./WorkCompanyGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports